import { render, staticRenderFns } from "./CambiaNota.vue?vue&type=template&id=73a37429&scoped=true&"
import script from "./CambiaNota.vue?vue&type=script&lang=js&"
export * from "./CambiaNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a37429",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/CambiaNota.vue
// module id = 384
// module chunks = 0